import { useEffect, useState } from "react";
import { Edit as EditIcon } from "@mui/icons-material";
import { t } from "i18next";
import api from "../../../../../helpers/api/Api";
import ApiUrls from "../../../../../helpers/urls/ApiUrls";
import { showStatus } from "../../../../../helpers/api/errors/ShowStatus";
import { anycastError } from "../../../functions/anycastError";
import EditModal from "../../../../../components/EditModal";
import AddSiteForm from "../../../components/addForm";

function EditSite({ site, handleCloseModal }) {
  const [newSite, setNewSite] = useState(site);
  const [modalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (modalOpen) {
      createFormData();
    }
  }, [modalOpen]);

  const createFormData = () => {
    const anycastArr = site?.anycast.split(",");
    const filteredAnycastArr = anycastArr.filter((a) => a !== "");

    setNewSite({
      ...site,
      anycast: filteredAnycastArr
    });
    setErrors({});
  }

  const checkInputs = () => {
    let temp_errors = {};

    if (newSite.mgmtip === "") {
      temp_errors.mgmtip = t("message.required", { item: t("site.management_ip") });
    }

    const anycast_error = anycastError(newSite.anycast);
    if (anycast_error.error) {
      temp_errors.anycast = anycast_error.error;
    }

    if (newSite.cachesizenum === "") {
      temp_errors.cachesizenum = t("message.required", { item: t("site.cache_size") });
    }
    if (newSite.inactivenum === "") {
      temp_errors.inactivenum = t("message.required", { item: t("site.cache_inactive") });
    }

    setErrors(temp_errors);
    setNewSite({
      ...newSite,
      anycast: anycast_error.filteredAnycast,
    });

    if (Object.keys(temp_errors).length === 0) {
      editSite();
    }
  }

  const editSite = () => {
    setLoading(true);
    let postFormData = new FormData();
    postFormData.append('uid', newSite.id);
    postFormData.append('mgmtip', newSite.mgmtip);
    postFormData.append('anycast', newSite.anycast);
    postFormData.append('cachesizenum', newSite.cachesizenum);
    postFormData.append('cachesizeunit', newSite.cachesizeunit);
    postFormData.append('inactivenum', newSite.inactivenum);
    postFormData.append('inactiveunit', newSite.inactiveunit);

    const snackArgs = {
      item: t("site.site"),
      op: t("global.edit")
    };

    api.post(ApiUrls.site.edit, postFormData)
      .then((response) => {
        setLoading(false);
        setModalOpen(false);
        showStatus(response.data.status, snackArgs);
        if (response.data.status === "success") {
          handleCloseModal();
        }
      })
      .catch((error) => {
        setLoading(false);
        showStatus("error", snackArgs);
      });
  }

  return (
    <EditModal
      title={t("button.edit", { item: t("site.site") })}
      onEdit={checkInputs}
      loading={loading}
      modalOpen={modalOpen}
      setModalOpen={setModalOpen}
      Icon={<EditIcon />}
    >
      <AddSiteForm
        formData={newSite}
        setFormData={setNewSite}
        errors={errors}
        setErrors={setErrors}
        isEdit
      />
    </EditModal>
  )
}

export default EditSite;
